import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Skeleton, Switch, notification, Popover } from 'antd';
import { useFirestore } from 'reactfire';
import { useMemo } from 'react';

const Ulcer = (props) => {

    const [isUlcer, setUlcer] = useState('No');
    const [isNeckNodes, setNeckNodes] = useState();
    const [popup, setPopup] = useState(false);


    const firestore = useFirestore();


    const [state, setState] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    
    const getSelectedFields = (event) => {
        setState({
            ...state,
            [event.target.name] : event.target.value
        });
    }

    useEffect(() => {
        getCurrentExmLocation();
    }, [props]);

    // useMemo(() => {
    //     if (state) {
    //         getCurrentExmLocation();
    //     }
    // }, [props])

    const getCurrentExmLocation = () => {
        setLoading(true);
        if (getGlobal().examination_location) {
            console.log(getGlobal().examination_location.Ulcer)
            setState(getGlobal().examination_location.Ulcer && getGlobal().examination_location.Ulcer);
            setUlcer(getGlobal().examination_location.Ulcer && getGlobal().examination_location.Ulcer.isUlcer
                ? getGlobal().examination_location.Ulcer.isUlcer : 'No');
            setNeckNodes(getGlobal().examination_location.Ulcer && getGlobal().examination_location.Ulcer.isPalpable)

        }
        assignDefaultValues();

        setLoading(false);
    }

    const assignDefaultValues = () => {
        if (!state) {
            assignDefaultValuesAnyways();
        }
    }

    const assignDefaultValuesAnyways = () => {
        setState({
            
        });
    }

    const getCheckBoxONChange = (value, target) => {
        setState({
            ...state,
            [target] : value
        });
    }

    const saveTheForm = () => {
        setLoadingBtn(true);
        let objectToSave = {
            ...getGlobal().examination_location,
            'Ulcer' : {'isUlcer': isUlcer, ...state}
        }

        if (getGlobal().examination_location_id) {
            firestore.collection('Examination').doc(getGlobal().examination_location_id).update({
                examination_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Updated',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        } else {
            firestore.collection('Examination').add({
                patient: firestore.collection("patients").doc(getGlobal().patientID),
                appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
                appointment_id: getGlobal().appointmentId,
                date: new Date(),
                examination_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Added',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        }
  

        
    }

    const deleteUlcer = () => {


        firestore.collection('Examination').doc(getGlobal().examination_location_id).update({
            examination_location: {...getGlobal().examination_location, Ulcer: null}
            
        }).then(() => {
            notification.open({
                message: 'Record Successfully Delete',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
            setGlobal({examination_location: {...getGlobal().examination_location, Ulcer: null}})
            setPopup(!popup)
            props.hasSaved();
            assignDefaultValuesAnyways();
        }).catch(() => {
            notification.open({
                message: 'An Error Occured',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        });



      

        // console.log("Ulcer Deleted")
    }


        
    
    const UlcerSelect = (event) => {
        setUlcer(event.target.value);
    }
    const NeckNodesSelect = (event) => {
        setNeckNodes(event.target.value);
        getSelectedFields(event);
    }
    return (
        <div>
            <React.Fragment>
            {/* <Switch name="Ulcer" onChange={UlcerSelectSwitch} defaultChecked={isUlcer ? true : false} checkedChildren="Yes" unCheckedChildren="No" size="large"/> */}
            {loading ? <Skeleton active /> : <>
                <Radio.Group name="Ulcer" value={isUlcer} onChange={UlcerSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                   

                <Popover
                    content={<a onClick={deleteUlcer}>Delete</a>}
                    title="Are you sure you want to delete All Record of Ulcer?"
                    trigger="click"
                    visible={popup}
                    onVisibleChange={() => {
                        if(getGlobal().examination_location && getGlobal().examination_location.Ulcer){setPopup(!popup)}
                    }}
                >
                    {/* <DeleteOutlined /> */}
                    <Radio.Button value={'No'}>No</Radio.Button>

                    
                
               </Popover>
               </Radio.Group>
               {isUlcer === 'Yes' && <Button className="SaveFormButton" loading={loadingBtn} style={{float: 'right'}} onClick={saveTheForm} type="primary">Save</Button>}
                    
                

                {isUlcer === 'Yes' ? 
                <div>
                        
                    
                    <ul className='showFieldsTable'>

                        

                        <li><span>Numbers</span>
                            <Radio.Group name="Numbers" value={state && state.Numbers} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Single'}>Single</Radio.Button>
                                <Radio.Button value={'Multiple'}>Multiple</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Site</span>
                            {/* <Radio.Group name="Site"  buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Nose'}>Nose</Radio.Button>
                                <Radio.Button value={'Face'}>Face</Radio.Button>
                                <Radio.Button value={'Neck'}>Neck</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group> */}

                                <Checkbox.Group name="Site" value={state && state.Site} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Site')} size="large">
                                    <Checkbox value="Nose" style={{ lineHeight: '32px' }}>
                                    Nose
                                    </Checkbox>
                                    <Checkbox value="Face" style={{ lineHeight: '32px' }}>
                                    Face
                                    </Checkbox>
                                    <Checkbox value="Neck" style={{ lineHeight: '32px' }}>
                                    Neck
                                    </Checkbox>
                                    <Checkbox value="Other" style={{ lineHeight: '32px' }}>
                                    Other
                                    </Checkbox>
                                </Checkbox.Group>
                            

                        </li>
                        <li><span>Type</span>
                            <Radio.Group name="Type"  value={state && state.Type} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Globular'}>Globular</Radio.Button>
                                <Radio.Button value={'Multinodular'}>Multinodular</Radio.Button>
                                <Radio.Button value={'Irregular'}>Irregular</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Shape</span>
                            <Radio.Group name="Shape" value={state && state.Shape} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Spherical'}>Spherical</Radio.Button>
                                <Radio.Button value={'Ovoid'}>Ovoid</Radio.Button>
                                <Radio.Button value={'Irregular'}>Irregular</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Edges</span>
                            <Radio.Group name="Edges" value={state && state.Edges} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Slopping'}>Slopping</Radio.Button>
                                <Radio.Button value={'Punched Out'}>Punched Out</Radio.Button>
                                <Radio.Button value={'Undermined'}>Undermined</Radio.Button>
                                <Radio.Button value={'Rolled Up'}>Rolled Up</Radio.Button>
                                <Radio.Button value={'Everted'}>Everted</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Margins</span>
                            <Radio.Group name="Margins" value={state && state.Margins} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Poorly Defined'}>Poorly Defined</Radio.Button>
                                <Radio.Button value={'Well Defined'}>Well Defined</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Floor</span>
                            <Radio.Group name="Floor" value={state && state.Floor} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Yellowish Slough'}>Yellowish Slough</Radio.Button>
                                <Radio.Button value={'Granulations'}>Granulations</Radio.Button>
                                <Radio.Button value={'Necrotic Tissues'}>Necrotic Tissues</Radio.Button>
                                <Radio.Button value={'Covered with Membrane'}>Covered with Membrane</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Surrounding Mucosa / Skin</span>
                            <Radio.Group name="Surrounding Mucosa / Skin" value={state && state['Surrounding Mucosa / Skin']} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Leukoplakia'}>Leukoplakia</Radio.Button>
                                <Radio.Button value={'Erythoplakia'}>Erythoplakia</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                                <Radio.Button value={'Indurated'}>Indurated</Radio.Button>
                                <Radio.Button value={'Ulcerated'}>Ulcerated</Radio.Button>
                                <Radio.Button value={'Fistula/Sinus'}>Fistula/Sinus</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Temperature</span>
                            <Radio.Group name="Temperature" value={state && state.Temperature} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Raised'}>Raised</Radio.Button>
                                <Radio.Button value={'Decreased'}>Decreased</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Tenderness</span>
                            <Radio.Group name="Tenderness" value={state && state.Tenderness} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Non-tender'}>Non-tender</Radio.Button>
                                <Radio.Button value={'Tender'}>Tender</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Base</span>
                            <Radio.Group name="Base" value={state && state.Base} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Indurated'}>Indurated</Radio.Button>
                                <Radio.Button value={'Nodular'}>Nodular</Radio.Button>
                                <Radio.Button value={'Superficial'}>Superficial</Radio.Button>
                                <Radio.Button value={'Pigmented'}>Pigmented</Radio.Button>
                                <Radio.Button value={'Morphic'}>Morphic</Radio.Button>
                                <Radio.Button value={'Baso-Squamous'}>Baso-Squamous</Radio.Button>
                                <Radio.Button value={'Thick'}>Thick</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Fixity to Underlying Structures</span>
                            <Radio.Group name="Fixity to Underlying Structures" value={state && state['Fixity to Underlying Structures']} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Not Fixed'}>Not Fixed</Radio.Button>
                                <Radio.Button value={'Fixed'}>Fixed</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Bleed on Touch</span>
                            <Radio.Group name="Bleed on Touch" value={state && state['Bleed on Touch']} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Consistency</span>
                            <Radio.Group name="Consistency" value={state && state.Consistency} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Firm'}>Firm</Radio.Button>
                                <Radio.Button value={'Soft'}>Soft</Radio.Button>
                                <Radio.Button value={'Hard'}>Hard</Radio.Button>
                                <Radio.Button value={'Firm to Hard'}>Firm to Hard</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Membrane</span>
                            <Radio.Group name="Membrane" value={state && state.Membrane} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Adherent/ Bleed'}>Adherent/ Bleed</Radio.Button>
                                <Radio.Button value={'Non-adherent'}>Non-adherent</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Size</span>
                            <Radio.Group name="Size" value={state && state['Size']} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'&#60; 2cm'}>&#60; 2cm</Radio.Button>
                                <Radio.Button value={'2-4cm'}>2-4cm</Radio.Button>
                                <Radio.Button value={'&#62; 4cm'}>&#62; 4cm</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Contraction of Muscles</span>
                            <Radio.Group name="Contraction of Muscles" value={state && state['Contraction of Muscles']} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'Doesn’t Change Size '}>Doesn’t Change Size </Radio.Button>
                                <Radio.Button value={'Size Increased'}>Size Increased</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Pulsatile</span>
                            <Radio.Group name="Pulsatile" value={state && state.Pulsatile} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                <Radio.Button value={'Size Decreased'}>Size Decreased</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Fluctuant</span>
                            <Radio.Group name="Fluctuant" value={state && state.Fluctuant} buttonStyle="solid" onChange={getSelectedFields} size="large">
                            <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Reducible</span>
                            <Radio.Group name="Reducible" value={state && state.Reducible} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Compressible</span>
                            <Radio.Group name="Compressible" value={state && state.Compressible} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Bruit</span>
                            <Radio.Group name="Bruit" value={state && state.Bruit} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Cause</span>
                            <Radio.Group name="Cause" value={state && state.Cause} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Traumatic'}>Traumatic</Radio.Button>
                                <Radio.Button value={'Malignant'}>Malignant</Radio.Button>
                                <Radio.Button value={'Infective'}>Infective</Radio.Button>
                                <Radio.Button value={'Neurological'}>Neurological</Radio.Button>
                                <Radio.Button value={'Arterial'}>Arterial</Radio.Button>
                                <Radio.Button value={'Venous'}>Venous</Radio.Button>
                            </Radio.Group>
                        </li>

                        <li><span>Neck Nodes</span>
                            <Radio.Group name="isPalpable" value={state && state.isPalpable} buttonStyle="solid" onChange={NeckNodesSelect} size="large" style={{marginTop: '20px'}}>
                                <Radio.Button value={'Not Palpable'}>Not Palpable</Radio.Button>
                                <Radio.Button value={'Palpable'}>Palpable</Radio.Button>
                            </Radio.Group>

                        {isNeckNodes === 'Palpable' ?
                          <ul className='nestedUl'>
                            <li>
                                <Radio.Group name="Palpable1" value={state && state.Palpable1} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                    <Radio.Button value={'Level 1'}>Level 1</Radio.Button>
                                    <Radio.Button value={'Level 2'}>Level 2</Radio.Button>
                                    <Radio.Button value={'Level 3'}>Level 3</Radio.Button>
                                    <Radio.Button value={'Level 4'}>Level 4</Radio.Button>
                                    <Radio.Button value={'Level 5'}>Level 5</Radio.Button>
                                    <Radio.Button value={'Level 6'}>Level 6</Radio.Button>
                                    <Radio.Button value={'Level 7'}>Level 7</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable2" value={state && state.Palpable2} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                    <Radio.Button value={'Single'}>Single</Radio.Button>
                                    <Radio.Button value={'Multiple'}>Multiple</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable3" value={state && state.Palpable3} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                    <Radio.Button value={'Ipsilateral'}>Ipsilateral</Radio.Button>
                                    <Radio.Button value={'Bilateral'}>Bilateral</Radio.Button>
                                    <Radio.Button value={'Contralateral'}>Contralateral</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable4" value={state && state.Palpable4} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                    <Radio.Button value={'&#60; 3 cm'}>&#60; 3 cm</Radio.Button>
                                    <Radio.Button value={'3 - 6 cm'}>3 - 6 cm</Radio.Button>
                                    <Radio.Button value={'&#62; 6 cm'}>&#62; 6 cm</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable5" value={state && state.Palpable5} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                    <Radio.Button value={'Tender'}>Tender</Radio.Button>
                                    <Radio.Button value={'Non-tender'}>Non-tender</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable6" value={state && state.Palpable6} buttonStyle="solid" onChange={getSelectedFields} size="large">
                                    <Radio.Button value={'Mobile'}>Mobile</Radio.Button>
                                    <Radio.Button value={'Fixed'}>Fixed</Radio.Button>
                                </Radio.Group>
                            </li>
                          
                           </ul>
                        
                      
                        : ''
                        }

                        </li>
 
                        <Button className="SaveFormButton" loading={loadingBtn} onClick={saveTheForm} type="primary">Save</Button>
                        
                    </ul>
                </div>

                : ''

                }
                </>}
            </React.Fragment>

        </div>
    );
}

export default Ulcer;
